import React from 'react';
import { Clock3, RefreshCcw } from 'lucide-react';
import { useAdminContext } from '../../../context/AdminContext';
import AdminStatusBadge from '../shared/AdminStatusBadge';
import LogoutActionButton from '../buttons/LogoutActionButton';
import SecondaryActionButton from '../buttons/SecondaryActionButton';

const AdminTopbar: React.FC = () => {
  const { dirty, draftMeta, saveMessage, logout, refreshDraft, saving } = useAdminContext();

  return (
    <div className="admin-panel sticky top-4 z-20 mb-6 flex flex-col gap-4 p-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-wrap items-center gap-3">
        <AdminStatusBadge tone={dirty ? 'warning' : draftMeta.hasUnpublishedChanges ? 'draft' : 'live'}>
          {dirty ? 'Unsaved draft changes' : draftMeta.hasUnpublishedChanges ? 'Draft ahead of live menu' : 'Draft matches live'}
        </AdminStatusBadge>
        {draftMeta.publishedAt && (
          <div className="inline-flex items-center gap-2 text-sm text-white/45">
            <Clock3 className="h-4 w-4" />
            Last published {new Date(draftMeta.publishedAt).toLocaleString()}
          </div>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {saveMessage && <div className="text-sm text-amber-100/65">{saveMessage}</div>}
        <SecondaryActionButton onClick={() => void refreshDraft()} disabled={saving}>
          <RefreshCcw className="h-4 w-4" />
          Refresh Draft
        </SecondaryActionButton>
        <LogoutActionButton onClick={() => void logout()} />
      </div>
    </div>
  );
};

export default AdminTopbar;

